// src/components/BenefitsOfOutsourcing.js
import React, { useState } from 'react';
import './BenefitsOfOutsourcing.css';

const BenefitsOfOutsourcing = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    practiceName: '',
    email: '',
    phone: '',
    specialty: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://formspree.io/f/xrejwqgl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Thank you! We will contact you shortly.' });
        setFormData({ fullName: '', practiceName: '', email: '', phone: '', specialty: '', message: '' });
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Something went wrong. Please try again.' });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus({ type: '', message: '' }), 5000);
    }
  };

  const benefits = [
  {
    title: 'What sets us apart from other medical billing companies is our cutting-edge technology, which anticipates and prevents coding and billing errors while maximizing output.',
    badge: 'PLATINUM WITH US',
    description: 'Our experienced personnel apply the newest guidelines to your claim. As part of our services, we provide automated data entry by integrating with your EHR and providing fully transparent Revenue Cycle Management reports.',
    highlight: '2.49%'
  },
  {
    title: 'Help You Reduce Cost',
    description: '"We will not surprise you with hidden fees or additional costs. That is not the way we conduct business." Providers Care Billing LLC is a constantly cost-effective and highly recommended medical billing revenue cycle management company. We provide accurate and cost-effective Medical Billing services in multi-specialty physician billing. Our charges start from as low as 2.49% of the collections and we get paid when you get paid! There is no hidden fee.',
  },
  {
    title: 'Core Management / Healthcare Experts',
    description: "Providers Care Billing LLC's core management includes direct control of employees and resources, including:",
    subItems: ['Insurance administration', 'Reimbursement and invoicing', 'Data analysis and reporting', 'Compliance']
  },
  {
    title: '99% Clients Satisfaction',
    description: 'Providers Care Billing LLC has maintained an average customer satisfaction rating of 99% since its inception. Our customers appreciate our commitment to quality service and responsiveness.',
    stat: '99%'
  },
  {
    title: '98.71% Clean Claims Submission',
    description: 'Our company has a clean claims submission rate of 98.71%. This means that we process all claims submitted by our clients within the specified time frame.',
    stat: '98.71%'
  },
  {
    title: 'Expert Medical Billing Staff',
    description: 'Providers Care Billing LLC is a client-centric company having a strong background in providing real-time medical billing, coding, and reconciliation services. Our team of experts provides exceptional support in all areas.'
  },
  {
    title: 'Patients Eligibility Verification',
    description: 'We use scanning and manual billing to ensure accurate patient eligibility. This includes verifying the insurance coverage and ensuring that the patient\'s information is correct.'
  },
  {
    title: 'Compliance',
    description: 'We are in compliance with all industry standards and regulations. We have a robust system in place to monitor and report any non-compliance issues.'
  },
  {
    title: 'Predictive Revenue Cycle Analysis',
    description: 'Our revenue cycle analysis helps you to improve your overall revenue by identifying areas of improvement and implementing strategies to increase revenue.'
  },
  {
    title: 'Free Up Your Time',
    description: 'As a physician, you get enough time in your day to focus on what matters most. With our automated billing system, you can free up more time for patient care.',
    subItems: ['Free text fields - add custom fields', 'Custom fields - create your own fields', 'Multiple fields per claim', 'Claim statuses - view status from pending to closed']
  },
  {
    title: "Practice's Financial Health",
    description: 'We want to help you maintain financial health by offering comprehensive reporting and analytics. Our tools allow you to track your revenue, expenses, and profitability in one place.'
  },
  {
    title: 'Eliminate Medical Billing Errors',
    description: "We believe that eliminating medical billing errors is essential to improving your practice's financial health.",
    subItems: ['Medical billing software - automates many tasks', 'Training and education - stay up-to-date', 'Feedback loop - helps us improve']
  },
  {
    title: 'Enhance Billing Cycle',
    description: "That's why we offer a range of tools and resources to help you streamline your billing process.",
    subItems: ['Automated billing - eliminates manual data entry', 'Invoice generation - professional invoices quickly', 'Payment reminders - ensure timely payments']
  },
  {
    title: 'Consistent Support',
    description: 'We understand that you need reliable support to help you succeed.',
    subItems: ['24/7 phone support', 'Online chat - real-time communication', 'Document management - secure storage']
  }
];

  return (
    <main className="benefits-outsource-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item active">Benefits Of Outsourcing Medical Billing</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="benefits-hero">
        <div className="container">
          <div className="benefits-hero-content">
            <h1 className="benefits-hero-title">Benefits Of Outsourcing</h1>
            <p className="benefits-hero-description">
              Outsourcing allows companies to decrease office expenses and employee expenses, resulting in increased revenue. 
              The benefits of outsourcing medical billing are significant. Hiring a single employee to handle coding or medical 
              billing responsibilities may easily cost three times the amount it costs to outsource medical billing and coding.
            </p>
            <p className="benefits-hero-description">
              At Providers Care Billing LLC, we help your practice/hospital step out from your pad, keep up with present and plan 
              for future with our Medical Billing, Coding, Medical Advisory, Physician Enrollment and Credentialing, and solving 
              your Old Claims through EHR software of your choice. We stay on top of ever-changing regulations, insurance 
              reimbursement policies, and medical coding guidelines that is why we have been successful in determining claims 
              management and reimbursement of our 2000+ providers.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Grid Section */}
      <section className="benefits-grid-section">
        <div className="container">
          <h2 className="benefits-section-title">
            Below Are The Benefits Of Outsourcing Medical Billing To Providers Care Billing LLC:
          </h2>
          
         <div className="benefits-grid">
  {benefits.map((benefit, index) => (
    <div className={`benefit-card ${benefit.badge ? 'has-badge' : ''}`} key={index}>
      {benefit.badge && <div className="benefit-badge">{benefit.badge}</div>}
      
      {benefit.highlight && !benefit.badge && (
        <div className="benefit-highlight">
          Starting at <span>{benefit.highlight}</span> of collections
        </div>
      )}
      
      {benefit.stat && (
        <div className="benefit-stat">{benefit.stat}</div>
      )}
      
      <h3 className="benefit-card-title">{benefit.title}</h3>
      <p className="benefit-card-description">{benefit.description}</p>
      
      {benefit.subItems && (
        <ul className="benefit-sub-list">
          {benefit.subItems.map((item, idx) => (
            <li key={idx}>
              <span className="check-icon">✓</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  ))}
</div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="benefits-cta-banner">
        <div className="container">
          <div className="cta-banner-content">
            <h2>Providers Care Billing LLC</h2>
            <p>Provider of Medical Billing Services</p>
            <button className="cta-banner-btn" onClick={() => document.querySelector('.consultation-form-wrapper').scrollIntoView({ behavior: 'smooth' })}>
              Get Started Today →
            </button>
          </div>
        </div>
      </section>

      {/* Consultation Form Section */}
      <section className="consultation-form-wrapper" id="consultation-form">
        <div className="container">
          <div className="form-container">
            <h2 className="form-main-title">Ready to Outsource Your Medical Billing?</h2>
            <p className="form-subtitle">Get a free consultation and see how much you can save</p>
            
            {submitStatus.message && (
              <div className={`status-message ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="consultation-form">
              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="text" name="practiceName" placeholder="Practice Name" value={formData.practiceName} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="specialty" placeholder="Medical Specialty" value={formData.specialty} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <textarea name="message" rows="3" placeholder="Tell us about your practice..." value={formData.message} onChange={handleChange}></textarea>
                </div>
              </div>
              <button type="submit" className="submit-form-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Schedule Free Consultation →'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BenefitsOfOutsourcing;